import { render, staticRenderFns } from "./FormQuestion.vue?vue&type=template&id=26800664&scoped=true"
import script from "./FormQuestion.vue?vue&type=script&lang=js"
export * from "./FormQuestion.vue?vue&type=script&lang=js"
import style0 from "./FormQuestion.vue?vue&type=style&index=0&id=26800664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26800664",
  null
  
)

export default component.exports